import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11.51 2.096a1.5 1.5 0 0 1 1.136.064c.352.168.547.46.645.62.107.174.217.399.323.614l2.14 4.335 4.788.701c.238.035.485.07.684.118.182.044.52.139.789.423.31.328.457.78.398 1.228-.051.387-.27.663-.392.806-.132.155-.312.328-.484.496l-3.463 3.372.818 4.764c.04.237.083.483.1.687.014.188.028.538-.158.882a1.5 1.5 0 0 1-1.045.759c-.385.07-.714-.051-.888-.123-.188-.079-.409-.196-.622-.308L12 19.283l-4.28 2.251c-.212.112-.433.23-.621.308-.174.072-.504.194-.888.123a1.5 1.5 0 0 1-1.045-.76c-.187-.343-.172-.693-.157-.881.016-.204.059-.45.1-.687l.816-4.764L2.463 11.5c-.172-.168-.352-.341-.485-.496-.122-.143-.34-.419-.391-.806-.06-.448.087-.9.398-1.228.269-.284.607-.38.79-.423.198-.048.445-.083.683-.118l4.787-.7 2.14-4.336c.107-.215.217-.44.324-.614.098-.16.293-.452.646-.62z"
	})
});
export default SvgStarFilled;
